import { useState, forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { Button as MuiButton } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';

import classes from './classes.module.scss';

const Button = props => {
  const {
    // key,  // React complains when attempting to read the passed key prop
    className,
    variant = 'contained',
    color = 'secondary',
    icon,
    startIcon,
    endIcon,
    onClick,
    disabled,
    label,
    children
  } = props;

  let sx = {
    margin: '0.5rem',
    boxShadow: 'none',
    fontSize: '1rem',
    textTransform: 'none'
  }

  if (props.sx) {
    sx = { ...sx, ...props.sx };
  }

  return (
    <MuiButton
      // key={buttonId}
      className={className}
      variant={variant}
      color={color}
      sx={sx}
      startIcon={icon || startIcon}
      endIcon={endIcon}
      disabled={disabled}
      onClick={onClick}>
      {label}
      {children}
    </MuiButton>
  )
}

const Select = props => {
  const {
    label,
    startIcon,
    endIcon,
    disabled,
    isMobile,
    menuItems,
    onOpen,
    keepOpen
  } = props;

  const [state, setState] = useState({
    isOpen: false,
    anchorEl: null
  });

  const onClick = event => {
    setState({
      isOpen: true,
      anchorEl: event.target
    });

    if (onOpen) {
      onOpen();
    }
  }

  const closeMenu = () => {
    setState({
      isOpen: false,
      anchorEl: null
    });
  }

  let button;
  if (isMobile) {
    button = (
      <Button
        endIcon={endIcon}
        onClick={onClick}
        disabled={disabled}
      >
        {startIcon}
      </Button>
    )
  } else {
    button = (
      <Button
        startIcon={startIcon}
        endIcon={endIcon}
        onClick={onClick}
        disabled={disabled}
      >
        {label}
      </Button>
    )
  }

  return (
    <>
      {button}
      <Menu anchorEl={state.anchorEl} open={state.isOpen} onClose={closeMenu}>
	{menuItems.map(item => {
	  const onItemClick = () => {
	    item.onClick();

	    if (!keepOpen) {
	      closeMenu();
	    }
	  }

	  if (item.checkbox) {
	    return (
	      <MenuItem key={item.key} value={item.value}>
		<Checkbox checked={item.checked} onClick={onItemClick} />
		<ListItemText primary={item.label} />
	      </MenuItem>
	    )
	  } else {
	    return (
	      <MenuItem key={item.key} value={item.value} onClick={onItemClick}>
		<ListItemText primary={item.label} />
	      </MenuItem>
	    )
	  }
	})}
      </Menu>
    </>
  )
}

const PrimaryButton = props => {
  const {
    label,
    onClick,
    icon,
    isMobile
  } = props;

  let color = 'primary';

  if (isMobile) {
    return (
      <Button color={color} onClick={onClick}>
        {icon}
      </Button>
    );
  } else {
    return (
      <Button color={color} startIcon={icon} onClick={onClick}>
        {label}
      </Button>
    );
  }
}

const Toolbar = props => {
  const {
    primaryButton,
    buttons
  } = props;

  const isMobile = useSelector(state => state.portalReducer.isMobile);

  return (
    <div className={classes.toolbar}>
      <div className={classes.actions}>
        {buttons && buttons.reverse().map(btn => <Button {...{ ...btn, isMobile }} />)}
        {primaryButton && <PrimaryButton {...{ ...primaryButton, isMobile }} />}
      </div>
    </div>
  );
}

export default Toolbar;
